"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Canonical schema for device metrics. All providers must map their internal data to these field names.
 * Fields that are not available for a given device or connection type must be returned as null.
 *
 * @typedef {Object} DeviceMetrics
 * @property {string|null}          device_id               - Hardware unique identifier (serial number)
 * @property {string|null}          device_model            - Hardware model name
 * @property {'wired'|'wifi'|null}  connection_type         - Active network connection type
 * @property {boolean}              has_link                - Whether the device has network connectivity
 * @property {string|null}          essid                   - WiFi network name (WiFi only)
 * @property {number|null}          signal_strength_dbm     - WiFi signal strength in dBm (WiFi only)
 * @property {number|null}          frequency_mhz           - WiFi frequency in MHz (WiFi only)
 * @property {number|null}          cpu_load_1m             - CPU load average over 1 minute
 * @property {number|null}          cpu_load_5m             - CPU load average over 5 minutes
 * @property {number|null}          cpu_load_15m            - CPU load average over 15 minutes
 * @property {number|null}          temperature_celsius     - CPU temperature in Celsius
 * @property {number|null}          memory_total_bytes      - Total physical memory in bytes
 * @property {number|null}          memory_free_bytes       - Free physical memory in bytes
 * @property {number|null}          device_uptime           - Seconds since device boot
 */

class DeviceMetricsProvider {
  /**
     * Collects all available device metrics and maps them to the canonical DeviceMetrics schema.
     * Implementations must always return the same field names regardless of the underlying device APIs.
     *
     * @returns {Promise<DeviceMetrics|null>} null if metrics cannot be collected
     */
  collectAll() {
    throw new Error('collectAll() not implemented');
  }
  getConnectionType() {
    throw new Error('getConnectionType() not implemented');
  }
  getNetworkMetrics() {
    throw new Error('getNetworkMetrics() not implemented');
  }
  getSystemMetrics() {
    throw new Error('getSystemMetrics() not implemented');
  }
  getDeviceName() {
    throw new Error('getDeviceName() not implemented');
  }
  getDeviceId() {
    throw new Error('getDeviceId() not implemented');
  }
}
var _default = exports.default = DeviceMetricsProvider;